import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { TrucksComponent } from './manage-trucks.component';
import { TableModule } from 'primeng';

const routes: Routes = [{ path: '', component: TrucksComponent, data: { title: 'Manage Trucks' } }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManageTrucksRoutingModule {}

@NgModule({
  imports: [
    ManageTrucksRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    TableModule,
  ],
  declarations: [TrucksComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ManageTrucksModule {}
